import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BatteryChargingFullIcon(props: IconProps) {
    return <Icon {...props} iconKey={"battery_charging_full"}/>
}
